// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'
import { Application } from './Application'

const app = new Application()
app.render()
